import React, { useState, useEffect } from "react";
import axios from "axios";
import $ from "jquery";
import "datatables.net-dt/js/dataTables.dataTables.js";
import { Icon } from "@iconify/react/dist/iconify.js";
import { Link } from "react-router-dom";
import { format } from "date-fns";
import { API_URL, getOrderStatuses } from "../utils/api";
import { ToastContainer, toast } from "react-toastify";

const PricesLayer = () => {
  const [OrdersList, setOrderList] = useState([]);
 const [statuschanged, setStatuschanged] = useState(false);
 let activeuser =localStorage.getItem('activeUser');
 activeuser =  JSON.parse(activeuser);
   

const Closeticket=(orderid) => {
  if(window.confirm("Are you sure want to close the Order?")){
  const formData={serviceStatus:4};
  axios
  .post(process.env.REACT_APP_API_BASE_URL+"order-update/"+orderid, { ...formData })
  .then((response) => {
     toast.success('Order closed sucessfully!!'); 
     setStatuschanged(!statuschanged);       
  })
  .catch((error) => {
    toast.error("Error on updating status:", error);
  });
  }
}
  useEffect(() => {
    // Fetch data
    axios
      .get(process.env.REACT_APP_API_BASE_URL+"order-all/"+activeuser.user_type+"/"+activeuser.id)
      .then((response) => {
        setOrderList(response.data.data);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  }, [statuschanged]);


  const [servicesList, setServicesList] = useState([]);
  const [locationsList, setLocationsList] = useState({
    1:"Liverpool, NSW",
    2:"Drummoyne, NSW"
  });
 
  useEffect(() => {

     // Fetch data
     axios.get(process.env.REACT_APP_API_BASE_URL+"service-list")
     .then(response => {
        const servicedata = response.data.data;
        let servicearray = [];
        
        servicedata.map((srvc, index)=>(
            servicearray[srvc.id] = srvc.title
        ))
        setServicesList(servicearray);

     })
     .catch(error => {
         console.error('Error fetching data:', error);
     });
    // Initialize DataTable after posts are rendered
    if (OrdersList.length > 0) {
      const table = $("#dataTable").DataTable({
        pageLength: 10,
      });
 
      return () => {};
    }

  }, []); // Re-run this effect when posts change
  const formatDate = (dateString) => {
    return format(new Date(dateString), "dd-MM-yyyy");
  };
 let Orderstatuses=getOrderStatuses();
  return (
    <div className="card basic-data-table">
      <div className="card-header">
        <h5 className="card-title mb-0"></h5>
      </div>
      <ToastContainer></ToastContainer>
      <div className="card-body" style={{overflow:"auto"}}>
        <table
          className="table bordered-table mb-0"
          id="dataTable"
          data-page-length={10}
        >
          <thead>
            <tr>
              <th scope="col">
                <div className="form-check style-check d-flex align-items-center">
                  <label className="form-check-label">S.L</label>
                </div>
              </th>
              <th scope="col">Location</th>
              <th scope="col">Service</th>
              <th scope="col">Name</th>
               <th scope="col">Phone</th>
              <th scope="col">Service Date</th>
              <th scope="col">Time</th>
              <th scope="col">Status</th>
             <th scope="col">Created Date</th>
              <th scope="col">Action</th>
            </tr>
          </thead>
          <tbody>
            {OrdersList.map((post, i) => (
              <tr key={"staff" + i}>
                <td>
                  <div className="form-check style-check d-flex align-items-center">
                    <label className="form-check-label">{i + 1}</label>
                  </div>
                </td>
                <td>{locationsList[post.branch]}</td>
                <td>{
                //let serviceids ="";// post.serviceId.split(",")
                post.serviceId.split(",").map((id) => servicesList[id]+", ") }</td>
               <td>

 <Link  to={'/'+JSON.parse(localStorage.getItem('activeUser')).user_type+`/customer-view/${post.user_id}`}
                                        className="text-success-main align-items-center justify-content-center"
                                    >
                                        {post.name}
                                    </Link>

               </td>
                  <td>{post.phone}</td>
                <td>{post.serviceDate}</td>
                <td>{post.requestTime}</td>
                <td>{Orderstatuses[post.serviceStatus]}</td>
                <td>{formatDate(post.createdAt)}</td>
                <td>
                  <Link
                    to={'/'+JSON.parse(localStorage.getItem('activeUser')).user_type+`/order-view/${post.orderid}`}
                    className="w-32-px h-32-px me-8 bg-success-focus text-success-main rounded-circle d-inline-flex align-items-center justify-content-center"
                  >
                    <Icon icon="lucide:view" />
                  </Link>

                  {((activeuser.user_type=="staff" || activeuser.user_type=="admin") && post.serviceStatus!=4 ) && <Link
                 
                 onClick={() => Closeticket(post.orderid)} title="Close Order"
                     className="w-32-px h-32-px me-8 bg-danger-focus text-danger-main rounded-circle d-inline-flex align-items-center justify-content-center"
                  >
                     <Icon icon="lucide:check" />
                  </Link>}

                  {(post.serviceStatus==4 ) && <Link
                   title=" Order Closed"
                     className="w-32-px h-32-px me-8 bg-success-focus text-success-main rounded-circle d-inline-flex align-items-center justify-content-center"
                  >
                     <Icon icon="lucide:check" />
                  </Link>}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default PricesLayer;
